import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class AttendanceManagerGuard implements CanActivate {

  constructor(private router: Router) { }

  canActivate(): boolean {
    const currentUser = JSON.parse(localStorage.getItem('currentUser'));
    
    if (currentUser && (currentUser.role === 'Admin' || currentUser.role === 'Attendance')) {
      // Both Admin and Attendance (Manager) roles can access these screens
      return true;
    }
    
    // Redirect unauthorized users
    this.router.navigate(['/login']);
    return false;
  }
}
